import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../Axios/AxiosBaseQuery';

// Create the API using createApi
export const GetPortfolioApi = createApi({
  reducerPath: 'GetPortfolioApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['portfolio'],
  staleTime: 1,
  endpoints: (builder) => ({
    getPortfolio: builder.query({
      query: () => ({ url: 'intern-service/profile/portfolio', method: 'GET' }),
      providesTags: ['portfolio'],
    }),
    savePortfolio: builder.mutation({
      query: ({ ...body }) => {
        let url = 'intern-service/profile/portfolio';
        let method = 'POST';
        return { url, method, body };
      },
      invalidatesTags: ['portfolio'],
    }),
    updatePortfolio: builder.mutation({
      query: ({ id, ...body }) => {
        let url = `intern-service/profile/portfolio/${id}`;
        let method = 'PATCH';

        return { url, method, body };
      },
      invalidatesTags: ['portfolio'],
    }),
    getPortfolioById: builder.query({
      query: (id) => ({ url: `intern-service/profile/portfolio/${id}`, method: 'GET' }),
    }),
    deletePortfolioId: builder.mutation({
      query: (id) => ({ url: `intern-service/profile/portfolio/${id}`, method: 'DELETE' }),
      invalidatesTags: ['portfolio'],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetPortfolioQuery,
  useLazyGetPortfolioByIdQuery,
  useDeletePortfolioIdMutation,
  useSavePortfolioMutation,
  useUpdatePortfolioMutation,
} = GetPortfolioApi;
// Export the auto-generated hooks and reducer
export default GetPortfolioApi.reducer;
